import React, { useEffect, useState } from 'react';
import classes from './MobileNav.module.scss';
import logo from '../../../media/logo/logo.png';
import Hamburger from 'hamburger-react';
import { useLocation } from 'react-router-dom';
import {useNavigate} from 'react-router-dom';
import NotificationDropdown from '../Navbar/NotificationDropdown';
import { useColorMode } from '@chakra-ui/react';

const MobileNav = ({
    sideDrawerToggleHandler, 
    showSideDrawer, 
    notifications,
    onNotificationClick,
    onMarkAllRead
}) => {
    const { colorMode, toggleColorMode } = useColorMode();
    const location = useLocation();
    const navigate = useNavigate();
    const [showNotifications, setShowNotifications] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const isHomePage = location.pathname === '/';
    // White icons only while they sit on the dashboard's dark hero photo. Once
    // the page scrolls the bar turns solid on every page, the dashboard
    // included: there the white icons used to vanish against the white cards.
    const onHero = isHomePage && !scrolled;
    const unreadCount = notifications.filter(notif => !notif?.isRead).length;
    let showHamburger;

    // The page scrolls inside <body> (index.scss), so this header stays at the
    // top of the screen while the page moves under it. Once it has, the header
    // gets a solid background, as the desktop one has.
    useEffect(() => {
        const onScroll = () => setScrolled(document.body.scrollTop > 0 || window.scrollY > 0);
        onScroll();
        document.body.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            document.body.removeEventListener('scroll', onScroll);
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    if (onHero) {
        showHamburger = (<div className={classes.DashMenuDiv} onClick={sideDrawerToggleHandler}>
            <Hamburger className={classes.HamburgerIcon} direction="right" toggled={showSideDrawer} label="Menu" />
        </div>)
    } else {
        showHamburger = (<div className={classes.NonDashMenuDiv} onClick={sideDrawerToggleHandler}>
            <Hamburger className={classes.HamburgerIcon} direction="right" toggled={showSideDrawer} label="Menu" />
        </div>)
    }

    return (
    <div className={`${classes.MobileNav} ${scrolled ? classes.solid : ''}`}>
        <div className={classes.LogoDiv} onClick={() => navigate('/')}>
            <img src={logo} alt='LOGO' />
        </div>

        <div className={classes.navActions}>
            <button
                className={`${classes.notificationBtn} ${
                    !onHero ? classes.inverted : ''
                }`}
                onClick={() => setShowNotifications(true)}
                aria-label="Notifications"
            >
                <i className="fas fa-bell"></i>
                {unreadCount > 0 && (
                    <span className={classes.notificationBadge}>
                        {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                )}
            </button>
            <div>
                <button
                    className={`${classes.darkModeBtn} ${
                        !onHero ? classes.inverted : ''
                    }`}
                    onClick={toggleColorMode}
                    aria-label={colorMode === "light" ? "Switch to dark mode" : "Switch to light mode"}
                >
                    {colorMode === "light" ? <i className="fas fa-moon"></i> : <i className="fas fa-sun"></i> }
                    
                </button>
            </div> 
            {showHamburger}
        </div>
        {showNotifications && (
            <div className={classes.mobileNotificationWrapper}>
                
                
                <NotificationDropdown 
            notifications={notifications}
            onClose={() => setShowNotifications(false)}
            onNotificationClick={onNotificationClick}
            onMarkAllRead={onMarkAllRead}
            isMobile={true}
        />
        
            </div>
        )}
        
    </div>
    );
}

export default MobileNav;